/* eslint-disable jsx-a11y/label-has-for */

// node modules
import React, { PureComponent } from 'react';
import { fieldPropTypes } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

// assets
import CssField from '../Field.scss';
import CssTextarea from './Textarea.scss';

class Textarea extends PureComponent {
  static propTypes = {
    ...fieldPropTypes,
  };

  render() {
    const {
      input,
      label,
      meta: { touched, error, form },
    } = this.props;
    const id = `${form}-${input.name}`;
    const inputClassNames = classNames('field__input', { 'field__input--error': touched && error });
    const labelClassNames = classNames('field__label', { 'field__label--error': touched && error });

    return (
      <div className="field field--textarea">
        <div className="field__wrapper">
          <textarea id={id} className={inputClassNames} rows="5" {...input} />
          <label htmlFor={id} className={labelClassNames}>
            {label}
          </label>
        </div>
      </div>
    );
  }
}

export default withStyles(CssField, CssTextarea)(Textarea);
